define('areas/home/commands/navigatecommand',["require", "exports", "durandal/app", "plugins/router", "models/account"], function (require, exports, App, Router, Account) {
    "use strict";
    var NavigateCommand = (function () {
        function NavigateCommand(router, usermanager, applications) {
            this._router = router;
            this._userManager = usermanager;
            this._applications = applications;
        }
        NavigateCommand.prototype.execute = function (symbol) {
            if (Account.Session.isExpired) {
                this.signOutAndReset();
                return;
            }
            this.run(symbol);
        };
        NavigateCommand.prototype.executeTwoParam = function (symbol, queryString) {
            if (Account.Session.isExpired) {
                this.signOutAndReset();
                return;
            }
            this.run(symbol, queryString);
        };
        NavigateCommand.prototype.signOutAndReset = function () {
            var alertMessage = $.t("app:modules.home.message_sessionExpired", { ifMissing: "Ihre Sitzung ist leider abgelaufen. Bitte melden Sie sich erneut an." });
            alert(alertMessage);
            this._userManager.signOut();
            this._applications.clear();
            this._router.navigate("#");
            App.trigger("authentication", true);
            window.location.reload();
        };
        NavigateCommand.prototype.run = function (symbol, queryString) {
            try {
                var absoluteUri = symbol.uri.absolute;
                if (queryString !== undefined && queryString !== null && queryString !== '') {
                    absoluteUri = absoluteUri + queryString;
                }
                if (symbol.type === "Application") {
                    if (symbol.children.length === 0) {
                        if (this.loadModule(symbol))
                            return;
                    }
                    else if (symbol.disableNavigateToFirstChild) {
                        Router.navigate(absoluteUri);
                    }
                    else {
                        var targetAbsoluteUri = symbol.children[0].uri.absolute;
                        if (queryString !== undefined && queryString !== null && queryString !== '') {
                            targetAbsoluteUri = targetAbsoluteUri + queryString;
                        }
                        Router.navigate(absoluteUri);
                        Router.navigate(targetAbsoluteUri);
                        return;
                    }
                }
                else if (symbol.type === "ApplicationLink") {
                    if (this.embedModule(symbol))
                        return;
                }
                Router.navigate(absoluteUri);
            }
            catch (ex) {
                alert(ex);
            }
        };
        NavigateCommand.prototype.loadModule = function (item) {
            var app = item.application;
            if (item.openInDialog) {
                // Send node to handle as needed
                App.showDialog('areas/' + app.configuration.moduleId, item);
                return true;
            }
            if (app != null && !app.embedApp) {
                var externalLink = app.link;
                if (externalLink != null) {
                    if (!item.openLinkInCurrentTab)
                        window.open(externalLink, "_blank");
                    else
                        window.open(externalLink, "_self");
                    return true;
                }
            }
            return false;
        };
        NavigateCommand.prototype.embedModule = function (item) {
            //if (app != null) {
            ////	var applications = new Applications();
            ////	var externalLink = applications.getExternalLink(app);
            //	var options = { replace: false, trigger: true };
            //	var url = item.uri.absolute + "?url=" + app.link;
            //	var childRouter = Router.createChildRouter();
            //	childRouter.navigate(url, options);
            //	//	Router.navigate("home/viewmodels/placeholder" + "?url=" + )
            //	//	if (externalLink != null) {
            //	//		window.open(externalLink, "_blank");
            //	//		return true;
            //	//	}
            //	return true;
            //}
            return false;
        };
        return NavigateCommand;
    }());
    return NavigateCommand;
});

